import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'  // サービスワーカー登録用のファイルをインポート

createApp(App).mount('#app')
